<template>
    <div class="notice-content">
        <car-headerbar title="自定义标签" :isCustomLeft="isCustomLeft"/>
        <div class="content_bgc">
            <div class="label_tag">
                <div v-for="(item, index) in tagList" :key="index" class="tag_item">
                    <me-popover v-model="showPopover[index]" trigger="click" theme="dark">
                        <div class="popover" @click="close(index)">
                            <me-icon name="delete-o" size=".5rem"/>
                            <div>删除</div>
                        </div>
                        <template #reference>
                            <me-tag round size="large" type="primary" >{{item}}</me-tag>
                        </template>
                    </me-popover>
                </div>
                <span class="input-adaptive-width">
                    <span>{{label}}</span>
                    <input name="newTag" type="text" maxlength="10" placeholder="选择或搜索标签" v-model="label" :class="{'dashed-border': label}" @input="(e)=>getTemplateLabel()" @keyup.enter="(e)=>addLabel()">
                </span>
            </div>
        </div>
        <div class="search_content" v-if="label">
            <div class="search_item" v-for="(item, index) in searchList" :key="index" @click="addLabel(item.labelName)">{{item.labelName}}</div>
        </div>
        <div class="all_tabs" v-else>
            <div class="tabs_title">全部标签</div>
            <div class="label_tag">
                <div
                    v-for="(item, index) in allTagList"
                    :key="index"
                    class="tag_item"
                    :class="{'has_tag': tagList.includes(item.labelName)}"
                    @click="addTagItem(item)"
                >
                    <me-tag
                        round
                        size="large"
                        :color="'#fff'"
                        text-color="#9298A8" 
                        >{{item.labelName}}</me-tag>
                </div>
                <div class="tab_btn">
                    <me-button size="small" round color="transparent" @click="addTagClick">
                        <div class="btn_padding">{{'+ 新建标签'}}</div>
                    </me-button>
                </div>
            </div>
        </div>
        <me-action-sheet v-model="show" title="新建标签" :closeable="false" :class="{addPadding}">
            <div class="action_content">
                <me-field v-model="addtag" label="" maxlength="10" placeholder="标签名称"/>
                <div class="action_btn">
                    <me-button size="small" type="primary" style="width: 30%" @click="addConfirm">完成</me-button>
                </div>
            </div>
        </me-action-sheet>
        <confirm @confirm="confirm"></confirm>
    </div>
</template>
<script>
import { addClass2, removeClass2 } from '@/util/status-util'
import { Toast } from '@guazi-fe/melon'
import confirm from '../compontents/confirm.vue'
import { Cell, CellGroup} from '@guazi-fe/melon'
import { Questionnaire } from '@/network'
import { mixin } from '@/mixins'
import browser from '@/util/browser'

export default {
    name: 'customLabel',
    data() {
        return {
            addtag: '',
            show: false,
            label: '',
            tagList: [],
            isCustomLeft: false,
            searchList: [],
            allTagList: [],
            timer: null,
            showPopover: [],
            addPadding: false
        }
    },
    // mixins: [mixin],
    components: { 
        confirm, 
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        query() {
            return this.$route.query
        },
    },
    watch: {
        tagList: {
            handler(newVal, oldVal) {
                this.$nextTick(() => {
                    let topContent = document.querySelector('.content_bgc').clientHeight
                    document.querySelector('.all_tabs').style.height = `calc(100% - 50px - 80px - ${topContent}px)`
                })
            },
            deep: true,
            immediate: true,
        }
    },
    created() {
        removeClass2('body', 'loading')
        this.tagList = this.$store.state.labelNames || []
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        // tagList最大为10 所以创建一个长度为10的数组
        this.showPopover = new Array(10).fill(false);
        Questionnaire.getTemplateLabel({tid: this.tid, labelName: ''}).then((res)=> {
            this.allTagList = res.data.data
        })
    },
    methods: {
        // 移动端输入时键盘弹起
        addEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            if (isAndroid) {
                this.addPadding = true
            }
        },
        removeEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            if (isAndroid) {
                this.addPadding = false
            }
        },
        addTagItem(item) {
            if (this.tagList.includes(item.labelName)) {
                let index = this.tagList.findIndex(tag => tag == item.labelName)
                this.tagList.splice(index, 1)
                return
            }
            if (this.tagList.length >= 10) {
                Toast('自定义标签最多添加10个')
                return
            }
            let vaildLabel = this.tagList.find(tag => tag == item.labelName)
            if (vaildLabel) {
                Toast('不能添加重复标签')
                return
            }
            this.tagList.push(item.labelName)
        },
        getTemplateLabel(type) {
            let params = {
              tid: this.tid,
            }
            if (!this.label) return
            params.labelName = this.label
            clearTimeout(this.timer);  
            this.timer = setTimeout(function() {  
                Questionnaire.getTemplateLabel(params).then((res)=> {
                    this.searchList = res.data.data
                })
            }.bind(this), 500); // 3000毫秒后执行  
        },
        addTagClick() {
            this.show = true
        },
        confirm() {
            let vaild = this.addLabel()
            if (vaild) return
            this.$store.commit('updateLabelNames', this.tagList)
            let query = {
                updateLabel: '1'
            }
            let name = 'edit'
            if (this.query.templateSetting) {
                name = 'templateSetting'
                query.updateRange = this.query.updateRange
            }
            this.$router.replace({
                name,
                params: {
                    pageId: this.pageId
                },
                query
            })
        },
        close(index) {
            this.tagList.splice(index, 1)
            this.showPopover[index] = false
        },
        addLabel(label) {
            if (!this.label) {
                return
            }
            if (this.tagList.length >= 10) {
                Toast('自定义标签最多添加10个')
                return true
            }
            let vaildLabel = this.tagList.find(item => item == (label || this.label))
            if (vaildLabel) {
                Toast('不能添加重复标签')
                return true
            }
            this.tagList.push(label || this.label)
            this.label = ''
        },
        addConfirm() {
            if (!this.addtag) {
                return
            }
            if (this.tagList.length >= 10) {
                Toast('自定义标签最多添加10个')
                return
            }
            let vaildLabel = this.tagList.find(item => item == this.addtag)
            if (vaildLabel) {
                Toast('不能添加重复标签')
                return
            }
            this.tagList.push(this.addtag)
            this.addtag = ''
            this.show = false
        },
    },
    mounted() {
        let body = document.body || document.documentElement
        body.style.overflow = 'hidden'
    },
    destroyed() {
        let body = document.body || document.documentElement
        body.style.overflow = 'auto'
    }
}
</script>
<style scoped lang="scss">
.tab_btn {
    position: relative;
    top: -4px;
}
  .addPadding{
      padding-bottom: 400PX!important;
  }
.action_content {
    ::v-deep .me-field__control {
        background-color: #f7f7f7;
    }
}
.popover {
    text-align: center;
    padding: 10px;
}
.search_content {
    background: #fff;
}
.search_item {
    padding: 10px;
    font-size: 16px;
    border: 1px solid #f7f7f7;
}
.btn_padding {
    padding: 0px 3px;
    color: #9298A8;
    line-height: 30px;
}
.all_tabs {
    // max-height: calc();
    overflow-y: auto;
    color: #c0c6cf;
    padding: 10px 15px;
    font-size: 14px;
    .tabs_title {
        padding-bottom: 10px;
    }
    ::v-deep .me-button {
        border: 1px solid #d8dde6 !important;
    }
}
.content_bgc {
    display: flex;
    background: #fff;
    padding: 10px 10px;
    max-height: 90px;
    overflow-y: auto;
    padding-bottom: 10px;
}
.dashed-border {
  border: 1px dashed #bfc5cf !important;
  border-radius: 10%;
}
/**自适应宽度的输入框**/
.input-adaptive-width{
  display: inline-block;
  min-width: 120px;
  max-width: 500px;
  position: relative;
  padding: 0.1rem;
  margin-bottom: 10px;
  height: 30px;
  padding: 0 5px;
  border-radius: 4px;
  white-space: nowrap;
}
.input-adaptive-width span {
  display: inline-block;
  height: 100%;
  background: inherit;/**继承父级**/
  padding: 0;
  white-space: nowrap;
  opacity: 0;
  font-size: 14px;
}
.input-adaptive-width ::v-deep input {
  display: inline-block;
  height: 100%;
  width: 100%;
  background: inherit;/**继承父级**/
  position: absolute;left: 0;top:0;
  padding: 0;
  opacity: 1;
  min-width: 20px;
  border: none;
  font-size: 14px;
  color: #333333;
  line-height: inherit;
  text-align: left;
  background-color: transparent;
  padding: 0 5px;
  border-radius: 4px;
}
.input-adaptive-width input::placeholder {
  color: #bfc5cf; /* 你想要的颜色代码 */
}
.input-adaptive-width ::v-deep input:focus{
  outline: 0;
}
    .action_content {
        padding: 20px 15px 30px;
    }
    .action_btn {
        width: 100%;
        text-align: center;
        margin-top: 20px;
    }
    .tag_item {
        margin: 0px 10px 10px 0px;
        border-radius: 10px;
        ::v-deep .me-tag{
            line-height: 20px;
        }
        &.has_tag{
            ::v-deep .me-tag{
                background-color: #e2f7eb!important;
                color: #05b555!important;
            }
        }
    }
    .label_row {
        margin: 0px 0.53333rem;
        padding: 8px 0px;
        border-bottom: 1px solid #d8dde6;

    }
    .label_tag {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: -10px;
        font-size: 15px;
    }
    .label_field {
        background-color: #fff;
    }
    .notice-content{
        height: 100%;
    }
    .defined-group{
        &:after{
            border-top: none;
        }
    }
    .defined-cell{
        margin-bottom: 20px;
        i[class^="me-icon"]{
            top: 5px;
        }
    }
    .label_img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.37333rem;
        font-weight: bold;
        color: #333;
        width: 5.76rem;
        height: 5.65333rem;
        text-align: center;
        img {
            width: 100%;
        }
    }
    ::v-deep .me-cell:not(.defined-cell){
        padding: 0;
    }
    ::v-deep .me-cell::after{
        border: none;
    }
    ::v-deep .me-field__body{
        border-radius: .1rem;
        background: #fff;
    }
    ::v-deep .me-field__control{
        padding: .1rem 5px;
        line-height: 28px;
        border-radius: 4px;
    }
    ::v-deep .me-button--primary {
        background-color: rgb(6, 180, 85);
    }
    ::v-deep .me-tag--primary{
        background: #e2f7eb;
        color: #05b555;
    }
    ::v-deep .me-tag__text{
        transform: scale(1);
    }
</style>
